import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import { updateRoleProperties } from '../actions';
import RoleFieldInput from '../components/RoleFieldInput';
import RoleFieldHeader from './RoleFieldHeader';

const RoleName = ({
  code,
  category,
  name,
  isSystem,
  isEditing,
  canEdit,
  updateName,
  validationErrors,
}) => {
  const validationError = findError(validationErrors, 'role', [fields.NAME]);

  return (
    <>
      {!isEditing && (
        <RoleFieldHeader
          code={code}
          category={category}
          value={name}
          icon="drivers license"
          canEdit={canEdit}
          isSystem={isSystem}
        />
      )}
      {canEdit && isEditing && (
        <>
          <ValidationSpan validationError={validationError} position="right" />
          <RoleFieldInput
            text={name}
            type="name"
            maxLength={globalFieldLengths.name}
            onChange={(value) => updateName(code, category, { name: value })}
            icon="drivers license"
            iconPosition="left"
            size="huge"
            className={validationClasses(validationError, 'aridhia-role-title')}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { roles: { update } } } },
  roles: { roles },
}, { category, code }) => {
  const item = findResult(roles, category, code);
  const isEditing = item ? item.isEditing : false;
  const validationErrors = item ? item.updateErrors : null;

  return (
    {
      isEditing,
      name: item ? item.name : '',
      isSystem: item ? item.system : false,
      canEdit: update && !item.system,
      validationErrors,
    }
  );
};

const mapDispatchToProps = {
  updateName: updateRoleProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleName);
